import React from 'react'
import { Link } from '@reach/router'
import { Flex, Text } from 'rebass'
import { css } from 'styled-components/macro'

import theme from '../../constants/theme'

export default ({ active, ...others }) => (
  <Flex
    as="li"
  >
    <Text
      as={Link}
      getProps={({ isCurrent }) => ({
        style: {
          color: isCurrent || active
            ? theme.colors.primary
            : theme.colors.text.light,
          fill: isCurrent || active
            ? theme.colors.primary
            : theme.colors.text.light,
        },
      })}
      css={css`
        text-decoration: none;
        font-weight: 600;
        transition: color .3s ease;
        padding: .75rem;

        &:hover {
          color: ${props => props.theme.colors.primary} !important;
        }
      `}
      {...others}
    />
  </Flex>
)
